import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PlanReviewConfirmationContent } from './components/planReviewConfirmationContent/PlanReviewConfirmationContent'

interface IPlanReviewConfirmationProps {
  isVisible: boolean
  onClose: () => void
}

export const PlanReviewConfirmation = ({ onClose, isVisible }: IPlanReviewConfirmationProps) => {
  const contentProps = useMemo(() => {
    return { onClose }
  }, [onClose])

  return (
    <ModalDialog
      content={PlanReviewConfirmationContent}
      onClose={onClose}
      contentProps={contentProps}
      show={isVisible}
      size={'xs'}
      closeOnOutsideClick={false}
    />
  )
}
